import { useState } from "react";
import PropTypes from "prop-types";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDAlert from "components/MDAlert";
import XemChungTuTrongApp from "components/XemChungTuTrongApp";

import { taiLenCloudinary } from "lib/cloudinary";

// Đính kèm ảnh/PDF chứng từ chuyển khoản — bắt buộc khi kế toán xác nhận
// đã thanh toán (xem giaoDichApi.xacNhanDaThanhToan). File lưu trên Cloudinary,
// Firestore chỉ giữ URL (chungTuUrl). URL Firebase Storage cũ vẫn xem được.
function UploadChungTu({ giaoDichId, value, onChange, batBuoc }) {
  const [dangTai, setDangTai] = useState(false);
  const [loi, setLoi] = useState("");

  async function chonFile(e) {
    const file = e.target.files?.[0];
    e.target.value = ""; // cho phép chọn lại đúng file đó lần sau nếu cần
    if (!file) return;

    setLoi("");
    setDangTai(true);
    try {
      const url = await taiLenCloudinary(file, { thuMuc: `chung-tu/${giaoDichId}` });
      onChange(url);
    } catch (err) {
      setLoi(err.message);
    } finally {
      setDangTai(false);
    }
  }

  let nhanNut = batBuoc ? "Đính kèm chứng từ (bắt buộc)" : "Đính kèm chứng từ (không bắt buộc)";
  if (dangTai) nhanNut = "Đang tải lên...";
  else if (value) nhanNut = "Đổi chứng từ khác";

  return (
    <MDBox>
      <MDButton component="label" variant="outlined" color="dark" size="small" disabled={dangTai}>
        {nhanNut}
        <input type="file" accept="image/*,application/pdf" hidden onChange={chonFile} />
      </MDButton>
      {value && (
        <MDBox mt={1.5}>
          <XemChungTuTrongApp url={value} tieuDe="Chứng từ đã tải lên" />
        </MDBox>
      )}
      {loi && (
        <MDBox mt={1}>
          <MDAlert color="error">{loi}</MDAlert>
        </MDBox>
      )}
    </MDBox>
  );
}

UploadChungTu.propTypes = {
  giaoDichId: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  batBuoc: PropTypes.bool,
};

UploadChungTu.defaultProps = {
  value: null,
  batBuoc: false,
};

export default UploadChungTu;
